import { render, staticRenderFns } from "./VerandaPanels.vue?vue&type=template&id=c2eeb848"
import script from "./VerandaPanels.vue?vue&type=script&lang=ts"
export * from "./VerandaPanels.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports